// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagePreview__container-ec3674 {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin-top: 4px;
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  background-size: cover;
  cursor: pointer;
  background-color: inherit;
  user-select: none;
  -webkit-user-select: none;
}

.ImagePreview__image-ad08f7 {
  max-height: 100%;
  max-width: 100%;
  background-color: inherit;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Text/LinkPreview/ImagePreview/ImagePreview.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,eAAA;EACA,yBAAA;EACA,iBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: relative;\n  margin-top: 4px;\n  border-radius: 8px;\n  overflow: hidden;\n  width: 100%;\n  background-size: cover;\n  cursor: pointer;\n  background-color: inherit;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n.image {\n  max-height: 100%;\n  max-width: 100%;\n  background-color: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImagePreview__container-ec3674`,
	"image": `ImagePreview__image-ad08f7`
};
module.exports = ___CSS_LOADER_EXPORT___;
